import request from '../../../axios';

const getUserCHatDetail = async (guid?: string) => {
  const {data}: {data: IGetUserCHatDetailData} = await request.get(
    `/api/v2/shop/chat/${guid}`,
  );
  return data;
};

export default getUserCHatDetail;
